import React from 'react';
import Admin from "../layouts/Admin";
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import storeConfig from '../store/storeConfig';

export const AppRoutes = () => {
    return (
        <Provider store={storeConfig()}>
        <BrowserRouter>
            <Switch>
                <Route path="/" component={Admin} />
            </Switch>
        </BrowserRouter>
        </Provider>
    )
}